/* @flow */
import Entity from 'lib/Entity';

class MessageSender extends Entity {
  getName(): string {
    // NOTE: v2 actually returns a signature for this field.
    // if we are getting this from the Apollo cache, it will
    // first check to see if we have a signature field, and then
    // will fall back to using the user's display name or name.
    return this.get('name');
  }

  // TODO does API actually return null or are our test fixtures off?
  getColor(): ?string {
    return this.get('color');
  }

  getUuid() {
    return this.get('uuid');
  }

  getInitials(): string {
    return this.get('initials');
  }

  getProfilePictureUrl(): ?string {
    return this.get('profile_picture_url');
  }
}

export default MessageSender;
